import { HoppModule } from "@hoppscotch/common/modules"
import { platform } from "@hoppscotch/common/platform"

const PUBLIC_ROUTES = ["/enter", "/oauth", "/device-login"]

const isPublicRoute = (path: string) =>
  PUBLIC_ROUTES.some((route) => path.startsWith(route))

export default <HoppModule>{
  async onBeforeRouteChange(to, _from, router) {
    // Do not block public routes
    if (isPublicRoute(to.path)) return

    // Wait for auth initialization to complete
    try {
      await platform.auth.waitProbableLoginToConfirm()
    } catch {
      // No probable user found → redirect to login
      router.push("/device-login")
      return
    }

    // Check if user is authenticated
    const currentUser = platform.auth.getCurrentUser()
    if (!currentUser) {
      router.push("/device-login")
    }
  },
}
